import _ from 'lodash';
import {useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import './ConfirmBooking.scss';
import {BOOKING_TYPES} from '../../common/config';
import InfoItem from '../../pages/afterLogin/PostBookingConfirmation/components/InfoItemUI';
import {
  getBookingConfirmationPageData,
  getBookingConfirmationPath,
  storeBookingConfirmationPageData,
} from '../../pages/afterLogin/PostBookingConfirmation/utils';
import {
  addSelectedPackage,
  changeClientPage,
  clearAppointmentBookingDetails,
  clearClassBookingDetails,
  clearPublicUser,
  verifyCouponCode,
  setSelectedFamilyMembers,
} from '../../redux/actions';
import {BASE_URL_WEB} from '../../utility/constants';
import FrequencyHelper from '../../utility/FrequencyHelper';
import {AxiosHelperPortal, showToast} from '../../utility/helperFunctions';
import {BookingSteps, CalendarFms, CampSteps} from '../index';
import BookingDateTimeUI from './components/BookingDateTimeUI';
import BookingCreditPreviewCard, {
  addMembershipParticipantNames,
  isMembershipV2Pack,
} from './components/BookingCreditPreviewCard';
import CampPacks from './components/CampPacks';
import CampQuestions from './components/CampQuestions';
import CouponCodeUI from './components/CouponCodeUI';
import FamilyMembers from './components/FamilyMembers';
import PackUI from './components/PackUI';
import RepeatClassesUI from './components/RepeatClassesUI';
import TrainerDetails from './components/TrainerDetails';
import {
  calculateFMQuantity,
  calculateIsPackageNeeded,
  campPackDefault,
  campPacksInstList,
  campPacksList,
  getClassPayload,
  getCampScheduleNotices,
  getMultiClassPackages,
  getRemainingForClass,
  getRemainingForSessions,
  getScheduledRepeatClasses,
  getSessionFm,
  getSessionPayload,
  getVerifyCoupon,
  hasSelectedMemberForMembershipPreview,
  isCreditsAvailableSession,
  isSubmitDisabled,
  shouldShowPackagePurchaseOptions,
  shouldShowMembershipCreditPreview,
  shouldShowRemainingPackageCredits,
  validateCampAnsweredQuestions,
} from './utils';
/**
 * !class rebook, existing member should be selected. book new members
 *  */
const ConfirmBooking = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const bookingDetails = useSelector(state => state.booking);
  const authDetails = useSelector(state => state.auth);
  const {isFromCheckIn} = useSelector(state => state.publicUser) || {};
  const [isInstallmentPlanSelected, setIsInstallmentPlanSelected] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  console.log('bookingDetails22', bookingDetails);
  const bookingType = bookingDetails?.classDetails
    ? BOOKING_TYPES.CLASS
    : BOOKING_TYPES.APPOINTMENT;
  const isCamp = bookingDetails?.classDetails?.isCamp;

  const isPrivateClass = bookingDetails?.classDetails?.access === 'private';
  const inst = bookingDetails?.classDetails?.inst;

  const repeatIdClasses = authDetails.companyData.calendar?.filter(
    classItem =>
      bookingDetails?.classDetails?.repeat_id && //! repeat_id should not be null/undefined
      bookingDetails?.classDetails?.repeat_id === classItem?.repeat_id
  );
  const isRepeatClass = Boolean(isCamp && bookingDetails?.classDetails?.repeat_id);
  const {camp_questions, group_class, multi_class_pack} = authDetails.companyData.services || {};

  const selectedServiceQuestion = group_class?.filter(
    ({uuid}) => bookingDetails?.classDetails?.serviceId === uuid
  )?.[0]?.questions;
  const Questions = camp_questions?.filter(campQues =>
    selectedServiceQuestion?.find(quesId => campQues.uuid === quesId)
  );
  const campQuestionsWithOrder = Questions?.map(Ques => ({
    ...Ques,
    order: selectedServiceQuestion?.indexOf(Ques.uuid),
  }));
  const campQuestions = campQuestionsWithOrder?.sort((a, b) => a.order - b.order);

  const isBookedIsCampNoBooking =
    bookingDetails?.classDetails?.isBooked &&
    isCamp &&
    'Please contact coach to add more family members';

  const [remainingSession, setRemainingSession] = useState({
    count: 0,
    showPackage: Boolean(bookingDetails?.selectedPackage),
    membership_pack: null,
    membershipV2Credits: null,
    multiDayCampSchedule: null,
    cards: [],
    isQuantityUnlimited: false,
  });
  let setPreSelectedPack = bookingDetails?.selectedPackage;
  if (!bookingDetails?.selectedPackage && isCamp) {
    setPreSelectedPack = campPackDefault({bookingDetails});
  }

  const selectedService = authDetails?.companyData?.services?.group_class?.find(
    service => service.uuid === bookingDetails?.classDetails?.serviceId
  );
  const haveKids = selectedService?.haveKids;

  const allClassList = useMemo(
    () =>
      getMultiClassPackages({
        bookingType,
        bookingDetails,
        multi_class_pack,
        group_class,
      }),
    []
  );
  //! keep
  const [multiClassId, setMultiClassId] = useState(null);
  const [couponCode, setCouponCode] = useState({
    userCode: '',
    loading: false,
  });
  const [loading, setLoading] = useState({
    isSubmitBtn: false,
  });
  //! keep

  const selectedPack = setPreSelectedPack;
  const selectedParticipantIds = (bookingDetails?.selectedFamilyMembers || [])
    .map(participant => (participant?.isParent ? '_parent' : participant?.uuid))
    .filter(Boolean)
    .sort()
    .join(',');
  const canUseMembershipCredits = remainingSession?.membershipV2Credits?.eligible === true;
  const displayRepeatIdClasses = useMemo(
    () =>
      getScheduledRepeatClasses({
        multiDayCampSchedule: remainingSession?.multiDayCampSchedule,
        repeatIdClasses,
      }),
    [remainingSession?.multiDayCampSchedule, repeatIdClasses]
  );
  const scheduleNotices = getCampScheduleNotices(remainingSession?.multiDayCampSchedule);
  const participantNamesById = useMemo(() => {
    const names = {};
    const primaryMember = authDetails?.companyData?.member;
    if (primaryMember?.id) {
      names[primaryMember.id] =
        primaryMember.name ||
        `${primaryMember.firstName || ''} ${primaryMember.lastName || ''}`.trim();
    }
    (bookingDetails?.selectedFamilyMembers || []).forEach(participant => {
      const participantId =
        participant?.isParent || participant?.uuid === '_parent'
          ? primaryMember?.id
          : participant?.uuid;
      if (participantId) {
        names[participantId] =
          `${participant?.firstName || ''} ${participant?.lastName || ''}`.trim() ||
          names[participantId];
      }
    });

    return names;
  }, [
    authDetails?.companyData?.member,
    bookingDetails?.selectedFamilyMembers,
  ]);
  //! states !//

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, []);
  console.log('authDetails222', authDetails);
  useEffect(() => {
    if (!authDetails.companyDataLoadingStatus) {
      remainingSessions();
    }
  }, [
    authDetails.companyDataLoadingStatus,
    bookingDetails?.trainingTime?.date,
    bookingDetails?.selectedFmUuidSession,
    selectedParticipantIds,
    bookingType,
  ]);

  // Auto-select primary/0th member for adult camps
  useEffect(() => {
    if (
      bookingType === BOOKING_TYPES.CLASS &&
      isCamp &&
      haveKids === false &&
      (!bookingDetails?.selectedFamilyMembers ||
        bookingDetails?.selectedFamilyMembers?.length === 0)
    ) {
      const primaryMember = authDetails?.companyData?.member;
      let selected = [];
      if (primaryMember?.firstName || primaryMember?.lastName) {
        selected = [
          {
            uuid: '_parent',
            isParent: true,
            firstName: primaryMember?.firstName || '',
            lastName: primaryMember?.lastName || '',
          },
        ];
      } else if (authDetails?.companyData?.familyMembers?.length > 0) {
        const fm0 = authDetails?.companyData?.familyMembers?.[0];
        selected = [
          {
            uuid: fm0?.uuid,
            isParent: false,
            firstName: fm0?.firstName || '',
            lastName: fm0?.lastName || '',
          },
        ];
      }
      if (selected.length > 0) {
        dispatch(setSelectedFamilyMembers(selected));
      }
    }
  }, [
    bookingType,
    isCamp,
    haveKids,
    bookingDetails?.selectedFamilyMembers,
    authDetails?.companyData?.member,
    authDetails?.companyData?.familyMembers,
    dispatch,
  ]);

  const remainingSessions = async () => {
    let response;
    setPageLoading(true);
    setLoading(p => ({...p, isSubmitBtn: true}));
    if (bookingType === BOOKING_TYPES.APPOINTMENT) {
      response = await getRemainingForSessions({
        authDetails,
        bookingDetails,
      });
    } else if (bookingType === BOOKING_TYPES.CLASS) {
      response = await getRemainingForClass({
        authDetails,
        bookingDetails,
      });
    }
    response && setRemainingSession(response);
    setLoading(p => ({...p, isSubmitBtn: false}));
    setPageLoading(false);
  };

  const _handleValidateCouponCode = async () => {
    setCouponCode(p => ({...p, loading: true}));
    let serviceId = '';
    if (bookingType === BOOKING_TYPES.APPOINTMENT) {
      serviceId = bookingDetails?.service?.uuid;
    } else {
      serviceId = bookingDetails?.classDetails?.serviceId;
    }

    const response = await getVerifyCoupon(couponCode?.userCode, serviceId, bookingType);
    setCouponCode(p => ({
      ...p,
      loading: false,
    }));
    dispatch(
      verifyCouponCode({
        couponDetails: response,
        isValid: Boolean(response),
      })
    );
  };

  const _handleOnClickBack = () => {
    if (bookingType === BOOKING_TYPES.APPOINTMENT) {
      dispatch(changeClientPage(bookingDetails?.trainer));
      return;
    }
    history.replace('/class-booking');
    dispatch(clearClassBookingDetails());
  };

  //! camp booking
  const isClassBookingValid = () => {
    if (haveKids && !bookingDetails?.selectedFamilyMembers?.length) {
      showToast.error('You must select at least one member before proceeding.');
      return;
    }

    if (!canUseMembershipCredits && inst?.length > 0 && !selectedPack?.isSelectBtn) {
      if (!selectedPack?.installmentType) {
        showToast.error('Please select a package!');
        return false;
      }
    }
    const haveQuestions = bookingDetails?.classDetails?.addQ;
    const questionErr =
      validateCampAnsweredQuestions({
        haveKids,
        selectedFamilyMembers: bookingDetails?.selectedFamilyMembers,
        campQuestions,
        haveQuestions,
      }) || '';
    if (questionErr !== '') {
      showToast.error(questionErr);
      return;
    }
    return true;
  };

  const campBooking = () => {
    console.log('isInstallmentPlanSelected', isInstallmentPlanSelected);
    if (!isClassBookingValid()) {
      return;
    }
    const payload = getClassPayload({
      selectedPack,
      bookingType,
      bookingDetails,
      authDetails,
      coupon: bookingDetails?.couponCode?.couponDetails,
      isCamp,
      multiClassId,
      group_class,
      multiDayCampSchedule: remainingSession?.multiDayCampSchedule,
    });
    console.log('===========');
    console.log('payload', payload);
    console.log('===========');
    _navToPaymentPage(payload);
  };
  const classPackageBuy = () => {
    if (!isClassBookingValid()) {
      return;
    }
    const payload = getClassPayload({
      selectedPack,
      bookingType,
      bookingDetails,
      authDetails,
      coupon: bookingDetails?.couponCode?.couponDetails,
      isCamp,
      multiClassId,
      group_class,
      multiDayCampSchedule: remainingSession?.multiDayCampSchedule,
      packQuantityFamilyMember: selectedService?.haveKids
        ? calculateFMQuantity({
            bookingDetails,
            packageQuantity: selectedPack?.quantity,
            remainingSession,
            group_class,
          })
        : 1,
    });
    payload.from = 'clp';
    console.log('payloadpayload23', payload);
    if (
      !canUseMembershipCredits &&
      calculateIsPackageNeeded({remainingSession, bookingDetails, haveKids})
    ) {
      _navToPaymentPage(payload);
    } else {
      classAddWithCredit(payload);
    }
  };

  const classAddWithCredit = async payload => {
    setLoading({isSubmitBtn: true});
    payload = _.omit(payload, ['payment_method', 'price', 'packageLabel', 'quantity']);
    console.log('===========');
    console.log('payload', payload);
    console.log('===========');

    const url =
      BASE_URL_WEB + `user-add-member-to-class?memberId=${authDetails.companyData.member.id}`;
    try {
      const response = await AxiosHelperPortal(url, 'post', payload);
      console.log('55response', response);
      if (response.status === 200) {
        const membershipV2CreditSummary =
          response?.data?.booked_appointment?.membershipV2CreditSummary;

        if (membershipV2CreditSummary) {
          const responseData = {
            ...response?.data,
            member: authDetails?.companyData?.member,
            membership_packs: {
              membershipV2: true,
              name: membershipV2CreditSummary?.planName || 'Membership',
              remaining: membershipV2CreditSummary?.creditsRemaining ?? 0,
              isQuantityUnlimited: membershipV2CreditSummary?.unlimited === true,
            },
            data: {ptRemaining: membershipV2CreditSummary?.creditsRemaining ?? 0},
            doNotShowOrder: 'true',
            bookedWithCredits: 'true',
            unlimited: membershipV2CreditSummary?.unlimited === true,
            membershipV2CreditSummary,
          };
          _moveToBookingConfirmationPage(responseData);
          dispatch(clearPublicUser());
          return;
        }

        const url = `${BASE_URL_WEB}client-class-member-service?serviceId=${
          response?.data?.booked_appointment?.serviceId
        }&noCards=${true}`;
        try {
          const res = await AxiosHelperPortal(url, 'get');
          const responseData = {
            order: response?.data?.order,
            booked_appointment: response?.data?.booked_appointment,
            subscription: response?.data?.subscription,
            member: authDetails?.companyData?.member,
            membership_packs: res?.data?.membership_pack,
            data: {ptRemaining: res?.data?.ptRemaining},
            doNotShowOrder: 'true',
            bookedWithCredits: 'true',
            unlimited: res?.data?.unlimited,
            nextInstallments: response?.data?.nextInstallments,
          };
          _moveToBookingConfirmationPage(responseData);
          dispatch(clearPublicUser());
        } catch (error) {
          console.log(error, error.res);
        }
      } else {
        showToast.error('Something went wrong!', 'Sorry!');
        setTimeout(() => {
          history.replace('/class-booking', {
            start: payload?.start,
          });
        }, 3000);
      }
    } catch (error) {
      console.log('error34', error);
      if (error?.response?.data?.code === 'CAMP_SCHEDULE_CHANGED') {
        await remainingSessions();
        showToast.warning(
          'Camp availability changed. Please review the updated dates and confirm again.'
        );
        return;
      }
      const errorMessage =
        error?.response?.data?.message || error?.data?.message || 'Something went wrong!';
      showToast.error(errorMessage, 'Sorry!');
    }
  };

  const _navToPaymentPage = payload => {
    if (bookingType === BOOKING_TYPES.APPOINTMENT) {
      history.push('/payment', {
        package: selectedPack,
        payload,
        bookingType: 'appointment',
        isInstallmentPlanSelected: isInstallmentPlanSelected,
      });
      return;
    }
    history.push('/payment', {
      package: selectedPack,
      familyMembers: bookingDetails?.classDetails?.familyMembers,
      selectedFamilyMembers: bookingDetails?.selectedFamilyMembers || [],
      payload,
      bookingType,
      isInstallmentPlanSelected: isInstallmentPlanSelected,
    });
  };
  console.log('selectedFamilyMembers', bookingDetails?.selectedFamilyMembers);
  const appointmentPackageBuy = () => {
    const payload = getSessionPayload({
      selectedPack,
      bookingDetails,
      companyData: authDetails.companyData,
      coupon: bookingDetails?.couponCode?.couponDetails,
    });
    _navToPaymentPage(payload);
  };

  const _handleSubmit = async () => {
    if (remainingSession?.membershipV2Credits?.membershipPaymentRequired === true) {
      showToast.error('Resolve the missed membership payment before booking this service.');
      return;
    }

    const isTncAccepted = _.has(authDetails.companyData?.member, 'toc');
    if (!isTncAccepted) {
      return showToast.error('Please accept the terms and privacy before proceeding!');
    }
    if (bookingType === BOOKING_TYPES.CLASS) {
      if (isCamp) {
        if (canUseMembershipCredits) {
          classPackageBuy();
        } else {
          campBooking();
        }
        return;
      }
      classPackageBuy();
    }
    if (bookingType === BOOKING_TYPES.APPOINTMENT) {
      if (isCreditsAvailableSession(remainingSession)) {
        await sessionBook();
      } else {
        appointmentPackageBuy();
      }
    }
  };

  const sessionBook = async () => {
    setLoading({isSubmitBtn: true});
    let payload = getSessionPayload({
      bookingDetails,
      companyData: authDetails.companyData,
    });
    payload = _.omit(payload, ['price', 'packageLabel', 'quantity']);
    console.log('===========');
    console.log('payload', payload);
    console.log('===========');
    try {
      const response = await AxiosHelperPortal(BASE_URL_WEB + 'add-appointment?', 'post', payload);
      console.log('response', response);
      if (response.status === 200) {
        _moveToBookingConfirmationPage(response?.data);
      } else {
        showToast.error('Something went wrong!', 'Sorry!');
        setTimeout(() => {
          history.replace('/class-booking', {
            start: payload?.start,
          });
        }, 3000);
      }
    } catch (error) {
      console.log('error', error);
      showToast.error(error.response?.data?.message, 'Sorry!');
      setTimeout(() => {
        history.replace('/class-booking', {
          start: payload?.start,
        });
      }, 3000);
    }
  };

  const _moveToBookingConfirmationPage = responseData => {
    console.log('responseDataasad', responseData);
    // dispatch(authCompanyData(authDetails.authDetails.username));
    dispatch(clearAppointmentBookingDetails());
    const bookingConfirmationPageData = getBookingConfirmationPageData({
      order: responseData?.order,
      service:
        bookingType === BOOKING_TYPES.APPOINTMENT
          ? responseData?.appointment
          : responseData?.booked_appointment,
      subscription: responseData?.subscription,
      member: authDetails?.companyData?.member,
      membership_pack: responseData?.membership_packs,
      ptRemaining: responseData?.data?.ptRemaining,
      doNotShowOrder: responseData?.doNotShowOrder,
      bookedWithCredits: responseData?.bookedWithCredits,
      isUnlimited: responseData?.unlimited,
      isFromCheckIn,
      nextInstallments: responseData?.nextInstallments,
      membershipV2CreditSummary:
        responseData?.membershipV2CreditSummary ||
        responseData?.appointment?.membershipV2CreditSummary ||
        responseData?.booked_appointment?.membershipV2CreditSummary,
    });
    const appointmentId =
      bookingType === BOOKING_TYPES.APPOINTMENT ? responseData?.appointment?.uuid : null;
    if (appointmentId) {
      storeBookingConfirmationPageData(appointmentId, bookingConfirmationPageData);
    }
    history.replace(getBookingConfirmationPath(appointmentId), bookingConfirmationPageData);
  };
  console.log('selectedpppp', selectedPack);

  const isMemberAlreadyBooked = () => {
    if (bookingType === BOOKING_TYPES.CLASS && haveKids === false) {
      //return true if bookingDetails?.classDetails?.familyMembers where isParent is true
      const parent = bookingDetails?.classDetails?.familyMembers?.find(member => member.isParent);
      if (parent) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  };

  const showMembershipCreditPreview = shouldShowMembershipCreditPreview({
    bookingType,
    isCamp,
    haveKids,
    bookingDetails,
    primaryMemberId: authDetails?.companyData?.member?.id,
    membershipV2Credits: remainingSession?.membershipV2Credits,
    participantPreviews: remainingSession?.membershipV2ParticipantPreviews,
    pageLoading,
  });
  const hasSelectedBookingMember = hasSelectedMemberForMembershipPreview({
    bookingType,
    isCamp,
    haveKids,
    bookingDetails,
    primaryMemberId: authDetails?.companyData?.member?.id,
  });
  const showPackagePurchaseOptions = shouldShowPackagePurchaseOptions({
    hasSelectedBookingMember,
    isCamp,
    remainingSession,
    bookingDetails,
    haveKids,
    pageLoading,
  });
  const showPackageSection = !isCamp && showPackagePurchaseOptions;
  const showCampPackageSection = isCamp && showPackagePurchaseOptions;
  const showCouponCodeSection = showPackagePurchaseOptions;
  const membershipV2ParticipantPreviews = addMembershipParticipantNames({
    participantPreviews: remainingSession?.membershipV2ParticipantPreviews,
    selectedParticipants: bookingDetails?.selectedFamilyMembers,
    primaryMember: authDetails?.companyData?.member,
  });
  const showRemainingPackageCredits = shouldShowRemainingPackageCredits({
    isCamp,
    membershipV2Credits: remainingSession?.membershipV2Credits,
    paidPackageCredits: remainingSession?.paidPackageCredits,
  });
  const showLegacyMembershipDetails =
    remainingSession?.membership_pack != null &&
    !isMembershipV2Pack(remainingSession?.membership_pack);

  return (
    <>
      <div className="main-content">
        <div className="page-content">
          <div className="container">
            <div className="_cardTop-hdr mb-4 text-center page-title">
              <h2 className="_text-dark">Confirm Booking</h2>
            </div>
            {bookingType === BOOKING_TYPES.APPOINTMENT ? (
              <BookingSteps step={4} />
            ) : (
              <CampSteps current={3} />
            )}
            <div className="_sessionBookingPage mt-2">
              <div className="container">
                <div className="row align-items-center">
                  <div className="booking_page">
                    <div className="_bookingTable-outter _list-outter">
                      <TrainerDetails trainerDetails={bookingDetails?.trainer} />
                      {showRemainingPackageCredits && (
                        <InfoItem
                          title="Remaining Session"
                          desc={
                            remainingSession?.paidPackageCredits?.unlimited
                              ? 'Unlimited'
                              : remainingSession?.paidPackageCredits?.count
                          }
                        />
                      )}
                      <InfoItem
                        title="Service"
                        desc={
                          bookingType === BOOKING_TYPES.APPOINTMENT
                            ? bookingDetails.service?.serviceName
                            : bookingDetails?.classDetails?.commonT ||
                              bookingDetails?.classDetails?.serviceName
                        }
                      />
                      {/* //! remaining membership */}
                      <>
                        {showLegacyMembershipDetails && (
                          <div>
                            <div>
                              <label className="form-label">
                                Membership Pack : <b>{remainingSession?.membership_pack.name}</b>
                              </label>
                            </div>
                            {remainingSession?.membership_pack.subscription_status == 'PENDING' && (
                              <div>
                                <div className="alert alert-warning">
                                  The Subscription status of this membership is pending.
                                  Subscription starts on{' '}
                                  <strong>
                                    {remainingSession?.membership_pack.subscription_start_date}
                                  </strong>
                                  .
                                </div>
                              </div>
                            )}
                            {remainingSession?.membership_pack.nextResetDate != null &&
                              remainingSession?.membership_pack.total_quantity != null && (
                                <div>
                                  <div>
                                    <strong>
                                      Session reset cycle:{' '}
                                      {remainingSession?.membership_pack.total_quantity} sessions
                                    </strong>{' '}
                                    are added &nbsp;
                                    <strong>
                                      {FrequencyHelper(
                                        remainingSession?.membership_pack.resetFrequency
                                      )}
                                    </strong>
                                    , to your remaining sessions
                                  </div>
                                  <div>
                                    <strong>Next session reset: </strong>
                                    {remainingSession?.membership_pack.nextResetDate}
                                  </div>
                                  {remainingSession?.membership_pack?.rollover === null && (
                                    <div>
                                      Unused sessions will be rolled over to the{' '}
                                      <strong>
                                        {FrequencyHelper(
                                          remainingSession?.membership_pack.resetFrequency,
                                          2
                                        )}
                                      </strong>
                                    </div>
                                  )}
                                </div>
                              )}
                          </div>
                        )}
                      </>
                      {/* //! remaining membership */}
                      {showMembershipCreditPreview && (
                        <BookingCreditPreviewCard
                          preview={remainingSession?.membershipV2Credits}
                          pack={remainingSession?.membership_pack}
                          participantPreviews={membershipV2ParticipantPreviews}
                          title="Membership Credits"
                          className="my-3"
                        />
                      )}
                      {/* //! show booking FMs | appointment #start */}
                      {bookingType === BOOKING_TYPES.APPOINTMENT && (
                        <InfoItem
                          title="Booked Family Member"
                          desc={
                            <CalendarFms
                              data={getSessionFm({
                                selectedFmUuidSession: bookingDetails?.selectedFmUuidSession,
                                compFm: authDetails.companyData?.familyMembers,
                                member: authDetails.companyData?.member,
                              })}
                              isCalendar={false}
                            />
                          }
                        />
                      )}

                      {/* //! show booking FMs | appointment #end */}
                      <BookingDateTimeUI
                        bookingType={bookingType}
                        bookingDetails={bookingDetails}
                        repeatIdClasses={displayRepeatIdClasses}
                        isRepeatClass={isRepeatClass}
                        scheduleNotices={scheduleNotices}
                      />
                      {isRepeatClass &&
                        remainingSession?.multiDayCampSchedule &&
                        displayRepeatIdClasses.length === 0 && (
                          <div className="alert alert-warning mt-3">
                            There are no available camp days remaining for the selected members.
                          </div>
                        )}
                      <br />
                      {bookingType === BOOKING_TYPES.CLASS && (
                        <FamilyMembers
                          isCamp={isCamp}
                          isBookedIsCampNoBooking={isBookedIsCampNoBooking}
                          isClassFull={bookingDetails?.classDetails?.isClassFull}
                          haveKids={haveKids}
                        />
                      )}
                      {isMemberAlreadyBooked() === false ? (
                        <>
                          {bookingType === BOOKING_TYPES.CLASS &&
                            isCamp &&
                            bookingDetails?.classDetails?.addQ &&
                            Boolean(bookingDetails?.selectedFamilyMembers?.length) && (
                              <CampQuestions campQuestions={campQuestions} />
                            )}
                          {/* //! packs ui todo */}
                          {isCamp && (
                            <>
                              <RepeatClassesUI
                                repeatIdClasses={displayRepeatIdClasses}
                                repeatId={bookingDetails?.classDetails?.repeat_id}
                                participantNamesById={participantNamesById}
                                hasSelectedRegistrants={Boolean(
                                  bookingDetails?.selectedFamilyMembers?.length
                                )}
                              />
                              {!bookingDetails?.classDetails?.inst && showCampPackageSection && (
                                <CampPacks
                                  selectedPackage={selectedPack}
                                  campPacksList={campPacksList({bookingDetails})}
                                  hasSquare={
                                    (authDetails?.companyData?.client_payment_modes?.includes(
                                      'square'
                                    ) &&
                                      authDetails?.companyData?.squareEnabled === true) ??
                                    false
                                  }
                                />
                              )}
                              {bookingDetails?.classDetails?.inst && showCampPackageSection && (
                                <CampPacks
                                  selectedPackage={selectedPack}
                                  campPacksList={campPacksInstList({bookingDetails})}
                                  isInst={true}
                                  setIsInstallmentPlanSelected={setIsInstallmentPlanSelected}
                                  hasSquare={
                                    (authDetails?.companyData?.client_payment_modes?.includes(
                                      'square'
                                    ) &&
                                      authDetails?.companyData?.squareEnabled === true) ??
                                    false
                                  }
                                />
                              )}
                            </>
                          )}
                          {/* //! for normal class/appointment packs */}
                          {showPackageSection && (
                            <>
                              <p className="text-dark bg-light text-left pl-3 py-2 my-3 text-dark fw-normal">
                                Please select a package from below.
                              </p>
                              {allClassList?.map((item, index) => (
                                <section key={item?.uuid}>
                                  {item?.packItems?.length || item?.servicePackages?.length ? (
                                    <>
                                      <label
                                        key={index}
                                        className="text-center d-block border-secondary text-dark"
                                        htmlFor="formGroupExampleInput"
                                      >
                                        {item?.name && (
                                          <span className="d-inline-block border py-2 px-4 rounded-pill border-dark">
                                            {item?.name}
                                          </span>
                                        )}
                                      </label>
                                      <p className="mb-3 text-muted fw-normal fs-6 text-center">
                                        {item?.subDescription}
                                      </p>
                                    </>
                                  ) : null}
                                  <div className="row row-cols-1 row-cols-md-4 mb-3 text-center">
                                    {(item?.typename === 'multi_class_pack'
                                      ? item?.packItems
                                      : item?.servicePackages
                                    )
                                      ?.sort((a, b) =>
                                        //! sort the packages based on label
                                        a?.label?.localeCompare(b?.label)
                                      )
                                      ?.map(serviceP => (
                                        <PackUI
                                          {...serviceP}
                                          key={serviceP?.label}
                                          isSelected={_.isEqual(selectedPack, serviceP)}
                                          coupon={bookingDetails?.couponCode?.couponDetails}
                                          _handleOnClick={() => {
                                            dispatch(addSelectedPackage(serviceP));
                                            setMultiClassId(
                                              item?.typename === 'multi_class_pack'
                                                ? item?.uuid
                                                : null
                                            );
                                          }}
                                        />
                                      ))}
                                  </div>
                                </section>
                              ))}
                            </>
                          )}
                          {showCouponCodeSection && (
                            <>
                              <br />
                              <CouponCodeUI
                                couponCodeLocalState={couponCode}
                                setCouponCode={setCouponCode}
                                _handleValidateCouponCode={_handleValidateCouponCode}
                              />
                            </>
                          )}
                        </>
                      ) : (
                        <div className="alert alert-warning mt-3">
                          You have already booked this class.
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="_btnGrp text-center py-4">
                    <button className="btn btn-outline-danger px-md-5" onClick={_handleOnClickBack}>
                      Back
                    </button>
                    {loading.isSubmitBtn ||
                    (bookingDetails?.selectedPackage?.installmentType === 'installment' &&
                      !selectedPack?.isSelectBtn) ? (
                      <></>
                    ) : (
                      <button
                        className="btn btn-primary px-5"
                        disabled={isSubmitDisabled({
                          remainingSession,
                          bookingType,
                          bookingDetails,
                          selectedPack,
                          loading,
                          isPrivateClass,
                          haveKids,
                        }) ||
                          (isRepeatClass &&
                            remainingSession?.multiDayCampSchedule &&
                            displayRepeatIdClasses.length === 0)}
                        onClick={_handleSubmit}
                      >
                        {loading.isSubmitBtn ? 'Loading...' : 'Confirm Booking'}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {pageLoading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}
    </>
  );
};

export default ConfirmBooking;
